__turbopack_context__.v({
  "card": "style-module-scss-module__FZA75a__card",
  "cardTitle": "style-module-scss-module__FZA75a__cardTitle",
  "cardsBlock": "style-module-scss-module__FZA75a__cardsBlock",
  "glass": "style-module-scss-module__FZA75a__glass",
  "image": "style-module-scss-module__FZA75a__image",
  "imageWrapper": "style-module-scss-module__FZA75a__imageWrapper",
  "inner": "style-module-scss-module__FZA75a__inner",
  "overlay": "style-module-scss-module__FZA75a__overlay",
  "section": "style-module-scss-module__FZA75a__section",
  "title": "style-module-scss-module__FZA75a__title",
});
